import React from "react";
import smsIcon from "../assets/sms.png"

const EmailInput = ({ email, setEmail, label = "Email Address", placeholder = "@example.com" }) => {
  return (
    <div className="mb-4">
      <label className="d-block text-start">{label}</label>
      <div className="position-relative">
        <input
          type="email"
          required
          placeholder={placeholder}
          className="input-base"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="input-start-icon-image"><img src={smsIcon} alt=""  /></div>
      </div>
    </div>
  );
};

export default EmailInput;
